import { Box, Typography } from "@mui/material";
import React from "react";
import Orangelogo from "../../assets/images/Orangelogo.png";
import Knowmorebtn from "../../components/button/Knowmorebtn";

const WhatwedoHeading = () => {
  return (
    <Box
      sx={{
        width: "100%",
        marginTop: "2rem",
        backgroundColor: "#ecebeb",
        display: "flex",
        flexDirection: { xs: "column-reverse", sm: "row" },
        padding: { xs: "0rem 1.8rem", sm: "0rem 3rem" },
      }}
    >
      <Box
        sx={{
          width: { xs: "100%", sm: "100%" },
        }}
      >
        <Box
          sx={{
            width: "4rem",
            marginTop: { xs: "0rem", sm: "2rem" },
          }}
        >
          <img src={Orangelogo} alt="" width="100%" />
        </Box>
        <Typography
          sx={{
            color: "rgba(35, 35, 37, 1)", // Add your desired color here
            fontFamily: "Montserrat",
            fontSize: { xs: "0.8rem", sm: "1rem" },
            marginTop: "0.8rem",
          }}
        >
          WHAT SETS US APART
        </Typography>
        <Typography
          variant="h4"
          sx={{
            fontFamily: "Montserrat",
            fontSize: { xs: "1.4rem", sm: "1.6rem" },
            fontWeight: "500",
            marginTop: "1.2rem",
          }}
        >
          Unparalleled Understanding of{" "}
          <span style={{ color: "rgba(255, 102, 0, 1)" }}>
            Marketing and Business Issues
          </span>
        </Typography>
        <Typography
          sx={{
            fontFamily: "Plus Jakarta Sans",
            marginTop: "1.2rem",
            marginBottom: "1.2rem",
            color: "#333333",
          }}
        >
          From digital strategy to retail expansion, our solutions drive ROI.
          Partner with us for strategic insights to elevate your business in
          today's dynamic market environment.{" "}
        </Typography>
      </Box>
    </Box>
  );
};

export default WhatwedoHeading;
